import { Button, styled } from '@mui/material';

const DateButton = styled(Button)`
  display: flex;
  flex-direction: column;
  gap: 2px;

  border-style: ${({ isFuture }) => (isFuture ? 'dashed' : 'solid')};
  border-width: ${({ isToday }) => (isToday ? '2px' : '1px')};

  background: ${({ isFuture, isToday }) =>
    !isFuture && !isToday
      ? `repeating-linear-gradient(
          45deg,
          #deebff,
          #deebff 4px,
          #ffffff 4px,
          #ffffff 8px
        )`
      : 'inherit'};

  &:hover {
    border-style: ${({ isFuture }) => (isFuture ? 'dashed' : 'solid')};
    border-width: ${({ isToday }) => (isToday ? '2px' : '1px')};
  }

  line-height: 1;

  padding: 6px 8px;
`;

export default DateButton;
